import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/concept-form";

export const pagingConceptForm = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getConceptFormById = (conceptFormId) => axios.get(API_PATH + "/get-by-id/" + conceptFormId);

export const saveConceptForm = conceptForm => axios.post(API_PATH + '/save', conceptForm);

export const deleteConceptForm = conceptFormId => axios.delete(API_PATH + '/mark-delete/' + conceptFormId)

export const downloadTemplate = () => {
    let url = API_PATH + "/download-template";
    return axios({
        url: url,
        method: "GET",
        responseType: "blob",
    });
}